import { DepartmentUserEntityModel } from "src/store/models/entity/departmentUser/entity";
import { DepartmentUserHelperModel } from "src/store/models/entity/departmentUser/helper";

export const departmentUserModels = {
  entity: DepartmentUserEntityModel,
  helper: DepartmentUserHelperModel,
};
